<template>
  <v-container fluid fill="height" fill-height >

    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-text>

            <v-carousel cycle :height="tamanioPantalla" hide-delimiter-background hide-delimiters show-arrows-on-hover :interval="100000">

              <template v-slot:prev="{ on, attrs }">
                <v-btn icon large color="white" v-bind="attrs" v-on="on" >  <v-icon> mdi-chevron-left </v-icon> </v-btn>
              </template>

              <!-- <v-carousel-item fill-height :contain="$vuetify.breakpoint.name === 'xs'? true : false" v-if="[334,7,28].includes( getdatosUsuarioERPERP.iderp )">

                <v-row justify="center" align="center" fill-height >
                  <v-col cols="12">
                    <v-card  class="pa-8 text-center rounded-xl shadowCard" color="">
                      <h2 class="text-h5 font-weight-bold mb-6">📚 Frase Motivacional del Día</h2>
                      <div>
                        <p class=" italic my-6" style="font-style: italic; font-size: 1.50rem;">"{{ frase }}"</p>
                        <p class="text-caption mt-4">— {{ autor }}</p>
                      </div>

                    </v-card>
                  </v-col>
                </v-row>
              </v-carousel-item> -->
              <v-carousel-item :contain="$vuetify.breakpoint.name === 'xs'? true : false" v-if="[334,966].includes( getdatosUsuarioERPERP.iderp )">
                <v-img src="@/assets/images/fondo/fondo1.png" aspect-ratio="2" contain></v-img>
              </v-carousel-item>

              <v-carousel-item :contain="$vuetify.breakpoint.name === 'xs'? true : false" >
                <v-img src="@/assets/images/fondo/fondo1.png" aspect-ratio="2" contain></v-img>
              </v-carousel-item>

              <v-carousel-item :contain="$vuetify.breakpoint.name === 'xs'? true : false" >
                <v-img src="@/assets/images/fondo/fondo2.png" aspect-ratio="2" contain></v-img>
              </v-carousel-item>

            </v-carousel>

          </v-card-text>
        </v-card>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import axios from 'axios';

  import { mapGetters } from 'vuex'

  export default {
    data(){
      return{
        socket: null,
        autor: '',
        frase: ''
      }
    },

    computed:{

      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getEscuela']),
      tamanioPantalla () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs':
            return 'auto';
          break;
          default:
            return this.$vuetify.breakpoint.height - 160
          break;
        }
      },
    },

    created( ){

      /*this.$http.get('motivacional' ).then(response=>{
        this.autor = response.data.author
        this.frase = response.data.quote_es
      }).catch( error =>{
        this.validarError( error.response.data.message )
      }).finally( () => { this.cargar = false })*/


    },

    methods:{
    }
  }

</script>

<style scoped>
</style>
